import React from "react";
import { Link } from "react-router-dom";
import { levelContentData } from "../Content/LevelContentData.js";
import { getUserRank } from "../../utils/permissions.js";
import '../Home/Home.css';

const Home = ({ user }) => {
  const userLevelContent = levelContentData
    .slice()
    .sort((a, b) => b.level - a.level)
    .find((item) => user.subscriptionLevel >= item.level);

    console.log("🏠 Home loaded for user level:", user.subscriptionLevel);
  return (
    <div className="home-section">
      <div className="home-section__layer">
        <div className="home-section__layer-photo">
          <section className="home-section__content">
            <div className="home-section__contentwrap">
              <h1 className="home-title">
                {userLevelContent?.title || "Welcome to VixAcademy 🚀"}
              </h1>
              <p className="home-description">
                {userLevelContent?.description || "Explore our content to get started."}
              </p>
              <p className="home-rank">
                Current Rank: <strong>{getUserRank(user.subscriptionLevel)}</strong>
              </p>

              <div className="home-button-container" style={{ marginTop: "2rem" }}>
                <Link 
                  to={user.subscriptionLevel > 0 ? "/content" : "/upgrade"} 
                  className="home-content-button">
                  {user.subscriptionLevel > 0 ? "START LEARNING →" : "LEARN MORE →"}
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
  
    </div>
  );
};

export default Home;


/*home.js a gorselli welcome yazisini alacagiz */
/* 
App.js = the skeleton that wraps everything and connects routes
Home.jsx = the content shown at / based on the user
LevelContent.jsx = the full detailed training/resources they’ve unlocked
 */